// removed by extract-text-webpack-plugin
module.exports = {"contractStatus":"theme--contractStatus--3Swk8yYG"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/contractStatus/theme.scss
// module id = 910
// module chunks = 0